<ngx-loading-bar></ngx-loading-bar><div [@routeAnimations]="prepareRoute(outlet)"><router-outlet #outlet="outlet"></router-outlet></div>